<template>
  <div class="content">
    <div class="wrap">
      <div class="content-top">
        <el-page-header @back="goBack" content="参数配置"></el-page-header>
      </div>

      <div class="content-box">
        <div class="content-box-1">
          <div class="title">本机设置</div>

          <div class="localhostConfig">
            <!-- <p>
              <span>服务请求地址：</span>
              <el-input v-model="form.serverUrl" placeholder="请输入"></el-input>
            </p> -->
            <p>
              <span>设备名称：</span>
              <el-input v-model="form.name" placeholder="请输入"></el-input>
            </p>
            <p>
              <span>授权码：</span>
              <el-input v-model="form.authcode" placeholder="请输入"></el-input>
            </p>
            <p>
              <span>数据请求频率：</span>
              <el-input v-model="form.requestFrequency" placeholder="请输入"></el-input>
              <span class="unit">/min</span>
            </p>
          </div>

          <div>
            <span class="button reset" @click="reset1">重置</span>
            <span class="button submit" @click="submit1">同步</span>
          </div>
        </div>

        <div class="content-box-2">
          <div class="content-box-left">
            <div class="title" style="color: #666;">前天车预警参数设置</div>
            <div class="beforeConfig">
              <p>
                <span>主升起高度：</span>
                <el-input v-model="form.main1Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>副升起高度：</span>
                <el-input v-model="form.aux1Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>小车位置：</span>
                <el-input v-model="form.tro1Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>主起升重量：</span>
                <el-input v-model="form.main1W" placeholder="请输入"></el-input>
                <span class="unit">/T</span>
              </p>
              <p>
                <span>副起升重量：</span>
                <el-input v-model="form.aux1W" placeholder="请输入"></el-input>
                <span class="unit">/T</span>
              </p>
            </div>
            <div>
              <span class="button reset" @click="reset2">重置</span>
              <span class="button submit" @click="submit2">同步</span>
            </div>
          </div>

          <div class="content-box-center">
            <div class="title" style="color: #666;">后天车预警参数设置</div>
            <div class="beforeConfig">
              <p>
                <span>主升起高度：</span>
                <el-input v-model="form.main2Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>副升起高度：</span>
                <el-input v-model="form.aux2Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>小车位置：</span>
                <el-input v-model="form.tro2Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>主起升重量：</span>
                <el-input v-model="form.main2W" placeholder="请输入"></el-input>
                <span class="unit">/T</span>
              </p>
              <p>
                <span>副起升重量：</span>
                <el-input v-model="form.aux2W" placeholder="请输入"></el-input>
                <span class="unit">/T</span>
              </p>
            </div>
            <div>
              <span class="button reset" @click="reset3">重置</span>
              <span class="button submit" @click="submit3">同步</span>
            </div>
          </div>

          <div class="content-box-right">
            <div class="title" style="color: #666;">其他预警设置</div>
            <div class="otherConfig">
              <p>
                <span>大车刚腿侧位置：</span>
                <el-input v-model="form.gan1Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>大车柔腿侧位置：</span>
                <el-input v-model="form.gan2Pos" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <p>
                <span>大车刚柔腿偏斜值：</span>
                <el-input v-model="form.ganDef" placeholder="请输入"></el-input>
                <span class="unit">/m</span>
              </p>
              <!-- <p>
                <span>风速预警值：</span>
                <el-input v-model="form.wind" placeholder="请输入"></el-input>
                <span class="unit">m/s</span>
              </p> -->
            </div>
            <div>
              <span class="button reset" @click="reset4">重置</span>
              <span class="button submit" @click="submit4">同步</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        id: '',
        form: {
          serverUrl: '',
          name: '',
          authcode: '',
          requestFrequency: '',
          main1Pos: '',
          aux1Pos: '',
          tro1Pos: '',
          main1W: '',
          aux1W: '',
          main2Pos: '',
          aux2Pos: '',
          tro2Pos: '',
          main2W: '',
          aux2W: '',
          gan1Pos: '',
          gan2Pos: '',
          ganDef: '',
          wind: ''
        }
      }
    },

    created() {
      const {id} = this.$route.query
      this.id = id
      this.getConfig()
    },

    methods: {
      // 获取配置
      getConfig() {
        myHttp.getEquipGantry({
          id: this.id
        }).then(res => {
          console.log(res);
          if(res.data.code === 200){
            this.form = res.data.data.equipGantry
          }
        })
      },

      submit1(){
        myHttp.updateEquipGantryNew({
          id: this.id,
          serverUrl: this.form.serverUrl,
          name: this.form.name,
          authcode: this.form.authcode,
          requestFrequency: this.form.requestFrequency
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.$message.success('操作成功！！')
            this.getConfig()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },

      reset1(){
        this.form.serverUrl = ''
        this.form.name = ''
        this.form.authcode = ''
        this.form.requestFrequency = ''
      },

      submit2(){
        myHttp.updateEquipGantryNew({
          id: this.id,
          main1Pos: this.form.main1Pos,
          aux1Pos: this.form.aux1Pos,
          tro1Pos: this.form.tro1Pos,
          main1W: this.form.main1W,
          aux1W: this.form.aux1W
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.$message.success('操作成功！！')
            this.getConfig()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },

      reset2() {
        this.form.main1Pos = ''
        this.form.aux1Pos = ''
        this.form.tro1Pos = ''
        this.form.main1W = ''
        this.form.aux1W = ''
      },

      submit3(){
        myHttp.updateEquipGantryNew({
          id: this.id,
          main2Pos: this.form.main2Pos,
          aux2Pos: this.form.aux2Pos,
          tro2Pos: this.form.tro2Pos,
          main2W: this.form.main2W,
          aux2W: this.form.aux2W
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.$message.success('操作成功！！')
            this.getConfig()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },

      reset3() {
        this.form.main2Pos = ''
        this.form.aux2Pos = ''
        this.form.tro2Pos = ''
        this.form.main2W = ''
        this.form.aux2W = ''
      },

      submit4(){
        myHttp.updateEquipGantryNew({
          id: this.id,
          gan1Pos: this.form.gan1Pos,
          gan2Pos: this.form.gan2Pos,
          ganDef: this.form.ganDef,
          wind: this.form.wind
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            this.$message.success('操作成功！！')
            this.getConfig()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },

      reset4() {
        this.form.gan1Pos = ''
        this.form.gan2Pos = ''
        this.form.ganDef = ''
        this.form.wind = ''
      },

      
      goBack(){
        this.$router.go(-1)
      }
    },
  }
</script>

<style scoped>
.wrap {
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
}

.content-top {
  height: 56px;
  padding: 16px;
  border-bottom: 2px solid #E7E7E7;
}

.content-box {
  padding: 16px;
}

.content-box-1 {
  height: 169px;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  padding: 16px;
  margin-bottom: 16px;
}

.title {
  text-align: left;
  font-size: 16px;
  color: #909399;
}

.title::before {
  display: inline-block;
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: #0D3A95;
  margin-right: 8px;
}

.content ::v-deep .el-input {
  width: 11.75rem;
  height: 30px;
}

.content ::v-deep .el-input__inner {
  width: 11.75rem;
  height: 30px;
  line-height: 30px;
  border-radius: 6px;
}

.localhostConfig {
  display: flex;
  justify-content: space-between;
  margin: 28px 0;
}

.localhostConfig p span:first-child {
  font-size: 14px;
  color: #666;
  margin-right: 1.25vw;
}

.button {
  display: inline-block;
  width: 55px;
  height: 28px;
  border-radius: 2px;
  background: #FFFFFF;
  box-sizing: border-box;
  border: 1px solid #999999;
  cursor: pointer;
  text-align: center;
  line-height: 28px;
  font-size: 13px;
}

.reset {
  color: #666;
  margin-right: 32px;
}

.submit {
  background-color: #4D6EB1;
  color: #fff;
}

.unit {
   font-size: 14px;
   color: #999;
   margin-left: 16px;
}

.content-box-2 {
  display: flex;
  justify-content: space-between;
}

.content-box-2 > div {
  width: 28.0729vw;
  height: 328px;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  padding: 16px;
  margin-right: 16px;
}

.content-box-2 > div:last-child {
  margin-right: 0;
}

.beforeConfig, .otherConfig {
  margin: 26px 0;
}

.beforeConfig p {
  margin-bottom: 10px;
}

.beforeConfig p:last-child, .otherConfig p:last-child {
  margin-bottom: 0;
}

.beforeConfig p span:first-child, .otherConfig p span:first-child {
  display: inline-block;
  width: 7vw;
  text-align: right;
  font-size: 14px;
  color: #9E9E9E;
  margin-right: 2.5vw;
}

.otherConfig p span:first-child {
  width: 9vw;
  margin-right: 1.5vw;
}

.otherConfig p {
  margin-bottom: 50px;
}
</style>